import { Component, Input } from "@angular/core";

@Component({
    selector: "app-html-dialog-content",
    template: `<div [innerHTML]="htmlContent"></div>`,
})
export class HtmlDialogContentComponent {
    @Input() htmlContent!: string;
}
